import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Box,
    Button,
    Typography,
    Paper
} from '@material-ui/core';
import { validateImage } from '../../utils/imageManager';
import Alert from '../../utils/alert';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    preview: {
        maxWidth: '800px',
        maxHeight: '800px',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '8px',
        background: theme.palette.grey[50],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        marginBottom: theme.spacing(0.5),
        transition: 'border-color 0.2s',
        minHeight: '100px',
    },
    image: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
        transition: 'opacity 0.2s',
    },
    noImage: {
        color: theme.palette.grey[400],
        fontSize: '1.2rem',
        padding: '1rem',
    },
    fileInput: {
        display: 'block',
        width: '100%',
        padding: '0.5em 0.75em',
        fontSize: '1.1rem',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '4px',
        background: theme.palette.common.white,
        outline: 'none',
        transition: 'border-color 0.2s',
        marginBottom: theme.spacing(0.5),
        '&:focus': {
            borderColor: theme.palette.primary.main,
        },
    },
    clearButton: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        fontSize: '1rem',
        padding: '0.5em 1.2em',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 'bold',
        transition: 'background-color 0.2s',
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
    },
}));

const MainImageSelector = ({ onFileChange, initialImageUrl = null }) => {
    const classes = useStyles();
    const [imagePreviewUrl, setUrl] = useState(null);
    const fileInputRef = useRef(null);

    const handleFileChange = e => {
        let file = e.target.files[0];

        if (!validateImage(file)) {
            Alert.error("対応していないファイルタイプです");
            setUrl(null);
            onFileChange(null);
            return;
        }

        let reader = new FileReader();

        reader.onloadend = () => {
            setUrl(reader.result)
        }

        reader.readAsDataURL(file);
        onFileChange(file);
    }

    const handleClear = () => {
        setUrl(null);
        onFileChange(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }

    const renderImage = () => {
        if (imagePreviewUrl) {
            return <img src={imagePreviewUrl} alt="preview" className={classes.image} />
        }
        return initialImageUrl
            ? <img src={initialImageUrl} alt="preview" className={classes.image} />
            : <Typography className={classes.noImage}>No Image</Typography>
    }

    return (
        <Box className={classes.wrapper}>
            <Paper className={classes.preview} elevation={1}>
                {renderImage()}
            </Paper>
            <input
                ref={fileInputRef}
                className={classes.fileInput}
                type="file"
                name="mainImage"
                accept="image/*"
                onChange={handleFileChange}
            />
            <Button
                onClick={handleClear}
                type="button"
                className={classes.clearButton}
                variant="contained"
            >
                選択解除
            </Button>
        </Box>
    )
}

export default MainImageSelector
